import React from 'react';
import styled from 'styled-components';

const AUTH_URL = process.env.NODE_ENV === 'production'
  ? '/auth/google'
  : 'http://localhost:3001/auth/google';

// Breakfast design system tokens (dark mode)
const colors = {
  primary: '#1D7A7A',
  primaryFill: 'rgba(29, 122, 122, 0.15)',
  title: '#FFFFFF',
  subtitle: 'rgba(255, 255, 255, 0.6)',
  fill: '#1a1a1a',
  notify: '#FA5D66',
  notifyFill: 'rgba(250, 93, 102, 0.15)',
  buttonText: '#FFFFFF',
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: ${colors.title};
  letter-spacing: -0.72px;
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 17px;
  font-weight: 450;
  color: ${colors.subtitle};
  margin: 0 0 8px 0;
`;

const SignInButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px;
  background: ${colors.primary};
  color: ${colors.buttonText};
  border-radius: 16px;
  text-decoration: none;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.17px;
  transition: background 0.2s;

  &:hover {
    background: #166363;
  }
`;

const ErrorMessage = styled.p`
  color: ${colors.notify};
  background: ${colors.notifyFill};
  font-size: 15px;
  font-weight: 450;
  padding: 12px 20px;
  border-radius: 12px;
  max-width: 400px;
  text-align: center;
  margin: 0;
`;

interface LoginPageProps {
  authError: boolean;
}

export const LoginPage: React.FC<LoginPageProps> = ({ authError }) => {
  return (
    <Container>
      <Title>Chattytown</Title>
      <Subtitle>Sign in to continue</Subtitle>
      {authError && (
        <ErrorMessage>
          Access denied. Your account is not authorized.
        </ErrorMessage>
      )}
      <SignInButton href={AUTH_URL}>
        Sign in with Google
      </SignInButton>
    </Container>
  );
};
